<script setup>
import { inject, onMounted, onUnmounted, ref } from 'vue';
import { useState } from '../hooks/useState';
import MapDialog from './MapDialog.vue';

const { item } = defineProps(['item'])
const [modalOpened, setModalOpened] = useState(false)

const [counter, setCounter] = useState(0)
const marker = ref(null)
const sign = ref(null)
const window = inject('window')

function clickHandler(event) {
    if (window.screen.width <= 580) return
    event.stopPropagation()
    setModalOpened(true)
}

function docClickHandler(event) {
    if (window.screen.width > 580) return

    if (!event.target.closest('.map-marker') || event.target.closest('.map-marker') != marker.value) {
        setCounter(0)
        sign.value.style.marginLeft = ''
        return
    }

    if (counter.value == 0) {
        const left = sign.value.getBoundingClientRect().left
        const right = window.screen.width - (sign.value.getBoundingClientRect().left + sign.value.getBoundingClientRect().width)

        if (left < 0) {
            sign.value.style.marginLeft = -left + 10 + 'px'
        }

        if (right < 0) {
            sign.value.style.marginLeft = (right - 10) + 'px'
        }

        if (left > 0 && right > 0) {
            sign.value.style.marginLeft = ''
        }

        if (item.coords[1] < 12 && !sign.value.style.top) {
            sign.value.style.top = getComputedStyle(sign.value).bottom
            sign.value.style.bottom = 'auto'
        }


        setCounter(1)

        return
    }

    if (counter.value == 1) {
        setModalOpened(true)
        setCounter(0)
        sign.value.style.marginLeft = ''
        return
    }
}

onMounted(() => {
    document.addEventListener('click', docClickHandler)
})

onUnmounted(() => {
    document.removeEventListener('click', docClickHandler)

})

</script>

<template>
    <button class="map-marker" :class="counter == 1 ? 'active' : ''" :id="item.id" :key="item.id" @click="clickHandler"
        ref="marker" :style="`left: ${item.coords[0]}%; top: ${item.coords[1]}%;`">
        <img :src="`${window.ASSETS_DIR}img/markers/${item.category.key || item.category}.png`" alt="">
        <div class="map-marker__sign" ref="sign">{{ item.title }}</div>
    </button>

    <MapDialog :item="item" v-model="modalOpened"></MapDialog>
</template>

<style>

</style>